import { insertStringAt } from '@helpers/utils'
import styles from './styles.module.scss'

type ProductTypeProps = {
  text: string | undefined
}
function ProductType({ text = '' }: ProductTypeProps) {
  const isOzTitle = /\d.*oz/.test(text)

  const titleArray = (
    isOzTitle
      ? insertStringAt({
          originalString: text,
          stringToInsert: ' ',
          position: text.indexOf('oz')
        })
      : text
  ).split(' ')

  return (
    <span className={styles.productType}>
      {!isOzTitle
        ? text
        : titleArray.map((partial, index) => {
            if (index > 1) {
              return <span key={partial}>&nbsp;{partial}</span>
            }
            return partial === 'oz' ? (
              <small key={partial}>{partial}</small>
            ) : (
              <span key={partial}>{partial}</span>
            )
          })}
    </span>
  )
}

export default ProductType
